import { render, staticRenderFns } from "./FestivalFooterBlock.vue?vue&type=template&id=3710ea54"
import script from "./FestivalFooterBlock.vue?vue&type=script&lang=js"
export * from "./FestivalFooterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports